<template>
    <section class="bg-white container-global q-py-xl">
        <div class="">
            <div class="header_section">
                <span class="header_section-sub-title">
                    بثلاث خطوات فقط
                </span>
                <h3 class="header_section-title">
                    تعرّف على ملاحظات المستخدمين وسلوكهم في منتجك الرقمي
                </h3>
                <p class="header_section-description">
                    اكتشف الجوانب الإيجابية وطوّرها، والجوانب السلبية وعالجها!
                </p>
            </div>
            <div class="box_cards rating-box-list">
                <div class="rating-box-item" :class="{ 'card-highlighted': cardHighlighted[0] }">
                    <span class="rating-box-bg-number" :class="{ 'badge-highlighted': badgeHighlighted[0] }">
                        <img src="@/assets/images/new-home/number_one.svg" alt="1" />
                    </span>
                    <div class="rating-box-content">
                        <h3 class="rating-box-title">اجمع التقييمات</h3>
                        <p class="rating-box-desc">
                            نفذ اختبارات تجربة المستخدم مباشرة على موقعك مع مستخدمين حقيقيين وبطريقة ومبتكرة وفعّالة                        </p>
                        <div class="rating-box-progress">
                            <div class="rating-progress-bar"
                                :class="{ 'animate': progressFilling[0], 'completed': progressCompleted[0], 'hidden': progressHidden[0] }">
                            </div>
                        </div>
                        <div class="rating-box-actions">
                            <span class="rating-box-btn" :class="{ 'btn-highlighted': button1Highlighted[0] }">آراء
                                وانطباعات</span>
                            <span class="rating-box-btn" :class="{ 'btn-highlighted': button2Highlighted[0] }">
                                بحث واستكشاف</span>
                            <span class="rating-box-btn"
                                :class="{ 'btn-highlighted': button3Highlighted[0] }">اختبارات
                                تفاعلية</span>
                        </div>
                    </div>
                </div>
                <div class="rating-box-item" :class="{ 'card-highlighted': cardHighlighted[1] }">
                    <span class="rating-box-bg-number" :class="{ 'badge-highlighted': badgeHighlighted[1] }">
                        <img src="@/assets/images/new-home/number_two.svg" alt="2" />
                    </span>
                    <div class="rating-box-content">
                        <h3 class="rating-box-title">حلل النتائج</h3>
                        <p class="rating-box-desc">اجمع النتائج وحللها بمساعدة الذكاء الاصطناعي، تقدر تطلب منه ملخص
                            آراء 1000+ مستخدم في ٣ سطور</p>
                        <div class="rating-box-progress empty">
                            <div class="rating-progress-bar"
                                :class="{ 'animate': progressFilling[1], 'completed': progressCompleted[1], 'hidden': progressHidden[1] }">
                            </div>
                        </div>
                        <div class="rating-box-actions">
                            <span class="rating-box-btn" :class="{ 'btn-highlighted': button1Highlighted[1] }">تقا
                                رير
                                تفصيلية</span>
                            <span class="rating-box-btn"
                                :class="{ 'btn-highlighted': button2Highlighted[1] }">بيانات كمية
                                ونوعية</span>
                            <span class="rating-box-btn"
                                :class="{ 'btn-highlighted': button3Highlighted[1] }">تحليلات
                                سلوكية</span>
                        </div>
                    </div>
                </div>
                <div class="rating-box-item" :class="{ 'card-highlighted': cardHighlighted[2] }">
                    <span class="rating-box-bg-number" :class="{ 'badge-highlighted': badgeHighlighted[2] }">
                        <img src="@/assets/images/new-home/number_three.svg" alt="3" />
                    </span>
                    <div class="rating-box-content">
                        <h3 class="rating-box-title">حسن موقعك</h3>
                        <p class="rating-box-desc">تقدر الآن تتخذ القرار الصحيح بكل ثقة لأنه مبني على بيانات حقيقية
                            وتواكب أفضل ممارسات تجربة المستخدم</p>
                        <div class="rating-box-progress empty">
                            <div class="rating-progress-bar"
                                :class="{ 'animate': progressFilling[2], 'completed': progressCompleted[2], 'hidden': progressHidden[2] }">
                            </div>
                        </div>
                        <div class="rating-box-actions">
                            <span class="rating-box-btn" :class="{ 'btn-highlighted': button1Highlighted[2] }" style="min-width: 40%;">
                                رفع نسبة التحوّل
                                </span>
                            <span class="rating-box-btn"
                                :class="{ 'btn-highlighted': button2Highlighted[2] }"  style="min-width: 25%;">رفع رضا المستخدم
                                </span>
                            <span class="rating-box-btn" :class="{ 'btn-highlighted': button3Highlighted[2] }" style="min-width: 25%;">تحسين الإيرادات
                                </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

// Progress bar animation state
const progressFilling = ref([false, false, false]);
const progressCompleted = ref([false, false, false]);
const progressHidden = ref([false, false, false]);
const isAnimating = ref(false);
const cardHighlighted = ref([false, false, false]);
const badgeHighlighted = ref([false, false, false]);
const button1Highlighted = ref([false, false, false]);
const button2Highlighted = ref([false, false, false]);
const button3Highlighted = ref([false, false, false]);

let animationObserver: IntersectionObserver | null = null;

const animateProgressBars = () => {
    if (isAnimating.value) return;
    isAnimating.value = true;

    // Reset all bars with proper delay
    progressFilling.value = [false, false, false];
    progressCompleted.value = [false, false, false];
    progressHidden.value = [false, false, false];
    cardHighlighted.value = [false, false, false];
    badgeHighlighted.value = [false, false, false];
    button1Highlighted.value = [false, false, false];
    button2Highlighted.value = [false, false, false];
    button3Highlighted.value = [false, false, false];

    // Slower, more relaxed timing
    const fillDuration = 2500; // 2.5 seconds for slower fill
    const delayBetweenCards = 1200; // 1.2 seconds between each card
    const hideDelay = 1000; // 1 second after fill before hiding
    const loopDelay = 1200; // 1.2 seconds before restarting loop
    const resetDelay = 500; // 0.5 seconds to reset before starting

    // Slower sequential effect delays within each card
    const badgeDelay = 0; // Start immediately
    const progressDelay = 800; // 0.8 seconds after badge
    const button1Delay = 1600; // 1.6 seconds after badge
    const button2Delay = 2400; // 2.4 seconds after badge
    const button3Delay = 3200; // 3.2 seconds after badge
    const cardDelay = 4000; // 4 seconds after badge

    const animateCard = (cardIndex: number) => {
        if (cardIndex > 2) {
            // After all three cards, wait then restart the loop
            setTimeout(() => {
                // Reset all states first
                progressFilling.value = [false, false, false];
                progressCompleted.value = [false, false, false];
                progressHidden.value = [false, false, false];
                cardHighlighted.value = [false, false, false];
                badgeHighlighted.value = [false, false, false];
                button1Highlighted.value = [false, false, false];
                button2Highlighted.value = [false, false, false];
                button3Highlighted.value = [false, false, false];

                // Reset animation flag
                isAnimating.value = false;

                // Wait a bit more before starting the new cycle
                setTimeout(() => {
                    animateProgressBars();
                }, resetDelay);
            }, loopDelay);
            return;
        }

        // 1. Start with badge highlight immediately
        badgeHighlighted.value[cardIndex] = true;

        // 2. Then start progress bar filling after 0.8 seconds
        setTimeout(() => {
            progressFilling.value[cardIndex] = true;
        }, progressDelay);

        // 3. Then highlight first button after 1.6 seconds
        setTimeout(() => {
            button1Highlighted.value[cardIndex] = true;
        }, button1Delay);

        // 4. Then highlight second button after 2.4 seconds
        setTimeout(() => {
            button2Highlighted.value[cardIndex] = true;
        }, button2Delay);

        // 5. Then highlight third button after 3.2 seconds
        setTimeout(() => {
            button3Highlighted.value[cardIndex] = true;
        }, button3Delay);

        // 6. Finally highlight the card after 4 seconds
        setTimeout(() => {
            cardHighlighted.value[cardIndex] = true;
        }, cardDelay);

        // Wait for all effects to complete before handling next step
        setTimeout(() => {
            // Stop filling and mark as completed
            progressFilling.value[cardIndex] = false;
            progressCompleted.value[cardIndex] = true;

            // Only reset everything after the third card (index 2)
            if (cardIndex === 2) {
                setTimeout(() => {
                    // Reset all cards after third card completes
                    progressHidden.value = [true, true, true];
                    cardHighlighted.value = [false, false, false];
                    badgeHighlighted.value = [false, false, false];
                    button1Highlighted.value = [false, false, false];
                    button2Highlighted.value = [false, false, false];
                    button3Highlighted.value = [false, false, false];

                    // Move to next card (which will restart the loop)
                    setTimeout(() => {
                        animateCard(cardIndex + 1);
                    }, delayBetweenCards);
                }, hideDelay);
            } else {
                // For first and second cards, just move to next card without resetting
                setTimeout(() => {
                    animateCard(cardIndex + 1);
                }, delayBetweenCards);
            }
        }, fillDuration + cardDelay); // Wait for all effects to complete
    };

    // Start the animation with initial delay
    setTimeout(() => {
        animateCard(0);
    }, resetDelay);
};

const setupProgressAnimations = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                animateProgressBars();
            }
        });
    }, {
        threshold: 0.3,
        rootMargin: '-10% 0px -10% 0px'
    });

    const ratingBoxes = document.querySelectorAll('.rating-box-item');
    if (ratingBoxes.length) {
        observer.observe(ratingBoxes[0]);
    }
    return observer;
};

onMounted(() => {
    animationObserver = setupProgressAnimations();
});

onUnmounted(() => {
    if (animationObserver) {
        animationObserver.disconnect();
    }
});
</script>

<style scoped lang="scss">


.box_cards {
    display: flex;
    gap: 32px;
    justify-content: center;
    margin: 40px 0 0 0;
    flex-wrap: wrap;

}

.rating-box-list {
    display: flex;
    gap: 32px ;
    justify-content: center;
    flex-wrap: wrap;
    @media (min-width: 1400px) {
        justify-content: space-between;

    }
}

.rating-box-item {
    position: relative;
    background: #fff;
    border: none;
    border-radius: 20px;
    box-shadow: 0 0px 8px 0 rgb(150 150 150 / 27%);
  max-width: 450px;
  min-width: 260px;
  width: 100%;
  min-height: 270px;
  padding: 32px 24px 24px 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  @media (max-width: 1600px) {
        max-width: 30%;
    }
  @media (max-width: 1400px) {
        max-width: 380px;
    }
}

.rating-box-item.card-highlighted {
    border: none;
    background: linear-gradient(135deg, #fff 0%, #f8f9ff 100%);
}

.rating-box-bg-number {
    position: absolute;
    left: 16px;
    top: 16px;
    z-index: 0;
    width: 150px;
    height: 150px;
    pointer-events: none;

    img {
        width: 100%;
        height: auto;
        display: block;
    }
}

.rating-box-content {
    position: relative;
    z-index: 1;
    width: 100%;
}

.rating-box-title {
    color: var(--bs-text-color);
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 8px;
    margin-top: 0;
    padding-inline-start: 60px;
}

.rating-box-desc {
    color: var(--bs-text-color);
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 24px;
    min-height: 48px;
    padding-inline-start: 60px;

}

.rating-box-progress {
    width: 100%;
    height: 12px;
    background: #f4f4f4;
    border-radius: 6px;
    margin-bottom: 24px;
    overflow: hidden;

    &.empty {
        background: #f4f4f4;
    }
}

.rating-progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #60E240 0%, #8CFD70 50%, #60E240 100%);
    border-radius: 6px;
    width: 0%;
    opacity: 0;
    transform: scaleX(0);
    transform-origin: left;
    transition: width 3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        opacity 1.2s cubic-bezier(0.4, 0, 0.2, 1),
        transform 1.2s cubic-bezier(0.4, 0, 0.2, 1),
        box-shadow 1s ease;
    box-shadow: 0 0 0 rgba(88, 84, 255, 0);
}

.rating-progress-bar.animate {
    width: 100%;
    opacity: 1;
    transform: scaleX(1);
}

.rating-progress-bar.completed {
    width: 100%;
    opacity: 1;
    transform: scaleX(1);
}

.rating-progress-bar.hidden {
    opacity: 0 !important;
    transform: scaleX(0.6) scaleY(0.6);
    transition: opacity 1.5s cubic-bezier(0.4, 0, 0.2, 1),
        transform 1.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.rating-box-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 0;
}

.rating-box-btn {
    background: #f4f4f4;
    color: #6f6f6f;
    border: none;
    border-radius: 30px;
    padding: 8px 10px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    position: relative;
    overflow: hidden;
    min-width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;

    &.main {
        background: #5854ff;
        color: #fff;
    }

    &.btn-highlighted {
        background: linear-gradient(135deg, #5854ff 0%, #8380DD 100%);
        color: #fff;
        // border: 1px solid rgba(255, 255, 255, 0.3);
    }
}

/* Responsive breakpoints */
@media (max-width: 1200px) {
    .header-title {
        font-size: 60px;
        line-height: 90px;
        max-width: 900px;
    }

    .header-description {
        font-size: 18px;
        max-width: 550px;
    }

    .box_cards {
        gap: 20px;
    }

    .rating-box-item {
        min-width: 220px;
        padding: 24px 12px 16px 12px;
    }

}

@media (max-width: 992px) {
    .header-title {
        font-size: 50px;
        line-height: 75px;
        max-width: 800px;
        margin-block: 25px;
    }

    .header-description {
        font-size: 17px;
        max-width: 500px;
        margin-block: 30px;
    }

    .box_cards {
        flex-direction: column;
        align-items: center;
    }

    .rating-box-item {
        width: 90vw;
        max-width: 400px;
    }
}

@media (max-width: 768px) {
    .header-title {

        font-size: 40px;
        line-height: 60px;
        max-width: 100%;
        margin-block: 20px;
        padding-inline: 20px;
    }

    .header-description {
        font-size: 16px;
        max-width: 100%;
        margin-block: 25px;
        padding-inline: 30px;
    }

    .button-container {
        flex-direction: column;
        gap: 12px;
        padding-inline: 20px;
    }

    .button-container .primary_btn,
    .button-container .primary_btn_outline {
        width: 100%;
        max-width: 280px;
        margin-inline: 0;
    }
}

@media (max-width: 576px) {
    .header-title {
        // font-size: 32px;
        // line-height: 48px;
        margin-block: 15px;
        padding-inline: 15px;
    }

    .header-description {
        font-size: 15px;
        margin-block: 20px;
        padding-inline: 20px;
    }

    .button-container {
        gap: 10px;
        padding-inline: 15px;
    }

    .button-container .primary_btn,
    .button-container .primary_btn_outline {
        max-width: 260px;
        font-size: 15px;
        padding-inline: 16px;
        padding-block: 12px;
    }
}

@media (max-width: 480px) {
    .header-title {
        // font-size: 28px;
        // line-height: 42px;
        margin-block: 12px;
        padding-inline: 10px;
    }

    .header-description {
        font-size: 14px;
        margin-block: 18px;
        padding-inline: 15px;
    }

    .button-container {
        gap: 8px;
        padding-inline: 10px;
    }

    .button-container .primary_btn,
    .button-container .primary_btn_outline {
        max-width: 240px;
        font-size: 14px;
        padding-inline: 14px;
        padding-block: 10px;
    }
}

@media (max-width: 360px) {
    .header-title {
        font-size: 24px;
        line-height: 36px;
        margin-block: 10px;
        padding-inline: 8px;
    }

    .header-description {
        font-size: 13px;
        margin-block: 15px;
        padding-inline: 12px;
    }

    .button-container {
        gap: 6px;
        padding-inline: 8px;
    }

    .button-container .primary_btn,
    .button-container .primary_btn_outline {
        max-width: 220px;
        font-size: 13px;
        padding-inline: 12px;
        padding-block: 8px;
    }
}

// @media (max-width: 1400px) {
//     .rating-box-list {
//         // flex-direction: column;
//         align-items: center;
//     }

//     .rating-box-btn {
//         font-size: 12px;
//     }
// }

@media (max-width: 1400px) {
    .rating-box-item {
        padding: 16px 4vw 16px 4vw;
    }

    .rating-box-btn {
        font-size: 11px;
    }

}
</style>
